// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BlueSlider {
    -webkit-appearance: none; /* Override default CSS styles */
    appearance: none;
    width: 100%;
    height: 1em;
    background: var(--GrayBlue);
    outline: none;
    opacity: 0.7;
    -webkit-transition: 0.2s;
    transition: opacity 0.2s;
    cursor: pointer;
}
.BlueSlider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 25px;
    height: 25px;
    background: var(--HighlightBlue);
    cursor: grabbing;
    border-radius: 5px;
}

.BlueSlider::-moz-range-thumb {
    width: 25px;
    height: 25px;
    background: var(--HighlightBlue);
}
.BlueSliderLabel {
    display: inline-block;
    padding-top: 0.5em;
    color: var(--Gray);
    font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/BlueSlider/BlueSlider.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB,EAAE,gCAAgC;IAC1D,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,2BAA2B;IAC3B,aAAa;IACb,YAAY;IACZ,wBAAwB;IACxB,wBAAwB;IACxB,eAAe;AACnB;AACA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gCAAgC;AACpC;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".BlueSlider {\n    -webkit-appearance: none; /* Override default CSS styles */\n    appearance: none;\n    width: 100%;\n    height: 1em;\n    background: var(--GrayBlue);\n    outline: none;\n    opacity: 0.7;\n    -webkit-transition: 0.2s;\n    transition: opacity 0.2s;\n    cursor: pointer;\n}\n.BlueSlider::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 25px;\n    height: 25px;\n    background: var(--HighlightBlue);\n    cursor: grabbing;\n    border-radius: 5px;\n}\n\n.BlueSlider::-moz-range-thumb {\n    width: 25px;\n    height: 25px;\n    background: var(--HighlightBlue);\n}\n.BlueSliderLabel {\n    display: inline-block;\n    padding-top: 0.5em;\n    color: var(--Gray);\n    font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
